/* Candle Out by ALEC — theme behaviour (no dependencies) */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var MAX_QTY = (window.theme && window.theme.maxQuantity) || 10;

  /* ---------- Announcement bar: rotate messages ---------- */
  function initAnnouncement(root) {
    var items = root.querySelectorAll('.announcement__item');
    if (items.length < 2 || reduceMotion) return;
    var i = 0;
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 3500;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, interval);
  }

  /* ---------- Header: menu panel + scrolled state ---------- */
  function initMenu() {
    var header = document.querySelector('[data-header]');
    var toggle = document.querySelector('[data-menu-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (!header) return;

    function onScroll() { header.classList.toggle('is-scrolled', window.scrollY > 8); }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    if (!toggle || !nav) return;
    function set(open) {
      if (open) document.documentElement.style.setProperty('--header-bottom', Math.max(0, header.getBoundingClientRect().bottom) + 'px');
      toggle.setAttribute('aria-expanded', String(open));
      nav.hidden = !open;
      document.body.classList.toggle('menu-open', open);
    }
    toggle.addEventListener('click', function () { set(toggle.getAttribute('aria-expanded') !== 'true'); });
    nav.addEventListener('click', function (e) { if (e.target.closest('[data-menu-link]')) set(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') { set(false); toggle.focus(); }
    });
    window.addEventListener('resize', function () { if (window.innerWidth >= 1100) set(false); });
  }

  /* ---------- Ritual scroll animation ---------- */
  function clamp(n) { return Math.min(1, Math.max(0, n)); }
  function seg(p, a, b) { return clamp((p - a) / (b - a)); }
  // Piecewise-linear interpolation through [p, value] stops.
  function lerpStops(p, stops) {
    if (p <= stops[0][0]) return stops[0][1];
    for (var i = 1; i < stops.length; i++) {
      if (p <= stops[i][0]) {
        var t = (p - stops[i - 1][0]) / (stops[i][0] - stops[i - 1][0]);
        return stops[i - 1][1] + (stops[i][1] - stops[i - 1][1]) * t;
      }
    }
    return stops[stops.length - 1][1];
  }
  function stepFor(p) { return p < 0.27 ? 0 : p < 0.42 ? 1 : p < 0.8 ? 2 : 3; }
  function fmt(totalSeconds) {
    var s = Math.max(0, Math.round(totalSeconds));
    return Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0');
  }

  function initRitual(section) {
    var steps = section.querySelectorAll('[data-step]');
    var timer = section.querySelector('[data-ritual-timer]');
    var minutes = parseInt(section.getAttribute('data-minutes'), 10) || 180;
    var lastStep = -1;

    var phone = window.matchMedia('(max-width: 767px)').matches;
    var dropSvh = phone ? 30 : 85;

    // Reduced motion: a still frame with the candle lit and the lid open.
    if (reduceMotion) {
      section.classList.add('is-static');
      section.style.setProperty('--candle-y', '0');
      section.style.setProperty('--candle-o', '1');
      section.style.setProperty('--flame', '1');
      section.style.setProperty('--glow', '0.55');
      section.style.setProperty('--p', '1');
      return;
    }

    function render(p) {
      var s = section.style;
      s.setProperty('--p', p.toFixed(4));
      s.setProperty('--candle-y', (-dropSvh * (1 - seg(p, 0.02, 0.26))).toFixed(2) + 'svh');
      s.setProperty('--candle-o', seg(p, 0.03, 0.12).toFixed(3));
      s.setProperty('--flame', lerpStops(p, [[0.3, 0], [0.36, 1], [0.86, 1], [0.885, 0]]).toFixed(3));
      s.setProperty('--glow', lerpStops(p, [[0.3, 0], [0.4, 0.55], [0.86, 0.55], [0.92, 0]]).toFixed(3));
      s.setProperty('--lid', lerpStops(p, [[0.8, 1], [0.865, 0.07]]).toFixed(3));
      s.setProperty('--smoke', lerpStops(p, [[0.885, 0], [0.91, 0.7], [1, 0]]).toFixed(3));
      s.setProperty('--smoke-y', (-160 * seg(p, 0.885, 1)).toFixed(1) + '%');
      if (timer) {
        // Base display reads hours:minutes, e.g. 1:00 for one hour.
        var left = Math.round(minutes * (1 - seg(p, 0.46, 0.78)));
        timer.textContent = Math.floor(left / 60) + ':' + String(left % 60).padStart(2, '0');
      }
      var step = stepFor(p);
      if (step !== lastStep) {
        lastStep = step;
        steps.forEach(function (el, i) {
          el.classList.toggle('is-active', i === step);
          if (i === step) el.setAttribute('aria-current', 'step'); else el.removeAttribute('aria-current');
        });
      }
    }

    // Phones: the sticky scroll scene doesn't fit under the browser bars and the buy bar,
    // so the steps sit in a normal list and the holder plays the whole sequence on a loop
    // while the section is on screen.
    if (phone) {
      section.classList.add('is-static', 'is-looping');
      var LOOP = 9000, HOLD = 1400, start = 0, raf = 0;
      function tick(now) {
        if (!start) start = now;
        var t = (now - start) % (LOOP + HOLD);
        render(Math.min(1, t / LOOP));
        raf = requestAnimationFrame(tick);
      }
      render(0);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) { if (!raf) { start = 0; raf = requestAnimationFrame(tick); } }
          else if (raf) { cancelAnimationFrame(raf); raf = 0; }
        }, { threshold: 0.25 }).observe(section.querySelector('.ritual__stage') || section);
      } else {
        raf = requestAnimationFrame(tick);
      }
      return;
    }

    var frame = 0;
    function update() {
      frame = 0;
      var rect = section.getBoundingClientRect();
      var total = section.offsetHeight - window.innerHeight;
      render(total > 0 ? clamp(-rect.top / total) : 0);
    }
    function onScroll() { if (!frame) frame = requestAnimationFrame(update); }
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }

  /* ---------- Sticky mobile buy bar ---------- */
  function initBuyBar(bar) {
    var link = bar.querySelector('a');
    document.body.classList.add('has-sticky-bar');
    function update() {
      var shop = document.getElementById('shop');
      var pastHero = window.scrollY > window.innerHeight * 0.6;
      var shopInView = false;
      if (shop) {
        var r = shop.getBoundingClientRect();
        shopInView = r.top < window.innerHeight && r.bottom > 0;
      }
      var visible = pastHero && !shopInView;
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', String(!visible));
      if (link) link.tabIndex = visible ? 0 : -1;
    }
    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  /* ---------- Cart drawer ---------- */
  var drawer = null;

  function openDrawer() {
    if (!drawer) return false;
    if (!drawer.open) drawer.showModal();
    return true;
  }
  function closeDrawer() { if (drawer && drawer.open) drawer.close(); }

  function setCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  // Replace the drawer (and cart page, if present) contents with freshly rendered sections.
  function renderSections(sections) {
    if (!sections) return;
    var html = sections['cart-drawer'];
    if (html && drawer) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-cart-drawer-content]');
      var current = drawer.querySelector('[data-cart-drawer-content]');
      if (fresh && current) current.replaceWith(fresh);
      var countEl = doc.querySelector('[data-cart-count-source]');
      if (countEl) setCount(parseInt(countEl.textContent, 10) || 0);
    }
  }

  function showError(message) {
    document.querySelectorAll('[data-cart-error]').forEach(function (el) {
      el.textContent = message || '';
      el.hidden = !message;
    });
  }

  function cartRequest(url, body) {
    body.sections = 'cart-drawer';
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || data.status) {
          var err = new Error(data.description || data.message || window.theme.strings.cartError);
          throw err;
        }
        return data;
      });
    });
  }

  function changeLine(line, quantity) {
    var lines = document.querySelectorAll('[data-cart-lines]');
    lines.forEach(function (el) { el.setAttribute('aria-busy', 'true'); });
    return cartRequest(window.theme.routes.cart_change_url, { line: line, quantity: Math.min(quantity, MAX_QTY) })
      .then(function (data) {
        showError('');
        if (document.querySelector('[data-cart-page]')) { window.location.reload(); return; }
        renderSections(data.sections);
      })
      .catch(function (e) {
        showError(e.message);
        lines.forEach(function (el) { el.removeAttribute('aria-busy'); });
      });
  }

  function initCart() {
    drawer = document.querySelector('[data-cart-drawer]');
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-open]') && drawer && !document.querySelector('[data-cart-page]')) {
        e.preventDefault();
        openDrawer();
        return;
      }
      if (e.target.closest('[data-cart-close]')) {
        var anchor = e.target.closest('a');
        if (!anchor) e.preventDefault();
        closeDrawer();
        return;
      }
      var change = e.target.closest('[data-line-change]');
      if (change) {
        e.preventDefault();
        changeLine(parseInt(change.getAttribute('data-line'), 10), parseInt(change.getAttribute('data-quantity'), 10));
      }
    });
    if (drawer) {
      // Close when clicking the backdrop.
      drawer.addEventListener('click', function (e) { if (e.target === drawer) closeDrawer(); });
    }
  }

  /* ---------- Product form ---------- */
  function initProduct(root) {
    var jsonEl = root.querySelector('[data-product-json]');
    var form = root.querySelector('[data-product-form]');
    if (!jsonEl || !form) return;
    var data = JSON.parse(jsonEl.textContent);
    var idInput = form.querySelector('[data-variant-id]');
    var addBtn = form.querySelector('[data-add-button]');
    var errorEl = form.querySelector('[data-form-error]');
    var priceEl = root.querySelector('[data-price-current]');
    var compareEl = root.querySelector('[data-price-compare]');
    var qtyInput = form.querySelector('[data-qty-input]');
    var fieldsets = form.querySelectorAll('[data-option-index]');
    var mainImg = root.querySelector('.gallery__main img');
    var thumbs = root.querySelectorAll('[data-gallery-thumb]');
    var statusEl = root.querySelector('[data-stock-status]');
    var noteEl = root.querySelector('[data-gallery-note]');
    var bar = root.querySelector('[data-atc-bar]');
    var barBtn = bar && bar.querySelector('[data-atc-bar-button]');
    var barPrice = bar && bar.querySelector('[data-atc-bar-price]');

    // Mobile sticky add-to-bag: visible while the main button is out of view.
    if (bar && 'IntersectionObserver' in window) {
      document.body.classList.add('has-sticky-bar');
      new IntersectionObserver(function (entries) {
        // Show whenever the main button is off screen, above or below, so a buy button is always in reach.
        var hidden = !entries[0].isIntersecting;
        bar.classList.toggle('is-visible', hidden);
        bar.setAttribute('aria-hidden', String(!hidden));
        if (barBtn) barBtn.tabIndex = hidden ? 0 : -1;
      }).observe(addBtn);
    }

    function setButtons(disabled, label) {
      [addBtn, barBtn].forEach(function (b) {
        if (!b) return;
        b.disabled = disabled;
        b.textContent = label;
      });
    }

    function selected() {
      var values = [];
      fieldsets.forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        values.push(checked ? checked.value : null);
      });
      return values;
    }

    function findVariant(values) {
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i];
        var match = values.every(function (val, idx) { return v.options[idx] === val; });
        if (match) return v;
      }
      return null;
    }

    function showImage(thumb) {
      if (!thumb || !mainImg) return;
      mainImg.src = thumb.getAttribute('data-src');
      mainImg.srcset = thumb.getAttribute('data-srcset');
      mainImg.alt = thumb.getAttribute('data-alt');
      thumbs.forEach(function (t) { t.setAttribute('aria-current', String(t === thumb)); });
    }

    // Mark option values that have no available variant given the other selections.
    function updateAvailability(values) {
      fieldsets.forEach(function (fs, idx) {
        fs.querySelectorAll('input').forEach(function (input) {
          var trial = values.slice();
          trial[idx] = input.value;
          var v = findVariant(trial);
          input.classList.toggle('is-unavailable', !v || !v.available);
        });
        var label = fs.querySelector('[data-option-selected]');
        if (label) label.textContent = values[idx] || '';
      });
    }

    function update() {
      var values = selected();
      var variant = findVariant(values);
      updateAvailability(values);
      if (errorEl) errorEl.textContent = '';
      if (!variant) {
        setButtons(true, window.theme.strings.unavailable);
        if (statusEl) { statusEl.textContent = window.theme.strings.unavailable; statusEl.classList.add('is-sold-out'); }
        return;
      }
      idInput.value = variant.id;
      setButtons(!variant.available, variant.available ? window.theme.strings.addToCartPrice.replace('__PRICE__', variant.price) : window.theme.strings.soldOut);
      if (statusEl) {
        statusEl.textContent = variant.available ? '' : window.theme.strings.soldOut;
        statusEl.classList.toggle('is-sold-out', !variant.available);
      }
      if (barPrice) barPrice.textContent = variant.price + ' · ' + variant.title.replace('Default Title', '');
      if (priceEl) priceEl.textContent = variant.price;
      if (compareEl) compareEl.textContent = variant.compare_at_price || '';
      if (variant.media_id) {
        var thumb = root.querySelector('[data-gallery-thumb][data-media-id="' + variant.media_id + '"]');
        showImage(thumb);
      }
      if (noteEl && !noteEl.hasAttribute('data-disabled')) {
        var ci = parseInt(noteEl.getAttribute('data-color-index'), 10);
        var finish = isNaN(ci) ? '' : variant.options[ci];
        noteEl.hidden = Boolean(variant.media_id) || !finish;
        noteEl.textContent = window.theme.strings.photoSoon.replace('__FINISH__', finish);
      }
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    fieldsets.forEach(function (fs) { fs.addEventListener('change', update); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showImage(t); }); });
    if (fieldsets.length) updateAvailability(selected());

    function setQty(n) { qtyInput.value = Math.min(MAX_QTY, Math.max(1, n || 1)); }
    var minus = form.querySelector('[data-qty-minus]');
    var plus = form.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () { setQty(parseInt(qtyInput.value, 10) - 1); });
    if (plus) plus.addEventListener('click', function () { setQty(parseInt(qtyInput.value, 10) + 1); });
    if (qtyInput) qtyInput.addEventListener('change', function () { setQty(parseInt(qtyInput.value, 10)); });

    form.addEventListener('submit', function (e) {
      if (!drawer) return; // fall back to normal form post to /cart/add
      e.preventDefault();
      var label = addBtn.textContent;
      setButtons(true, window.theme.strings.adding);
      cartRequest(window.theme.routes.cart_add_url, {
        items: [{ id: parseInt(idInput.value, 10), quantity: parseInt(qtyInput.value, 10) || 1 }]
      })
        .then(function (res) {
          renderSections(res.sections);
          showError('');
          openDrawer();
        })
        .catch(function (err) {
          if (errorEl) errorEl.textContent = err.message;
        })
        .finally(function () {
          setButtons(false, label);
        });
    });
  }

  // Lid open / closed wipe: sweeps once when it scrolls into view, then follows the slider.
  function initCompare(fig) {
    var range = fig.querySelector('[data-compare-range]');
    if (!range || fig.dataset.ready) return;
    fig.dataset.ready = '1';
    var touched = false;
    function set(p) { fig.style.setProperty('--p', p); range.value = Math.round(p * 100); }
    range.addEventListener('input', function () { touched = true; set(range.value / 100); });
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      io.disconnect();
      var start = null;
      // 1 = all lid open, 0 = all lid closed. Open -> closed -> settle in the middle.
      var keys = [[0, 1], [0.55, 0], [1, 0.5]];
      function frame(t) {
        if (touched) return;
        if (start === null) start = t;
        var k = Math.min((t - start) / 2600, 1);
        var a = keys[0], b = keys[1];
        if (k > keys[1][0]) { a = keys[1]; b = keys[2]; }
        var local = (k - a[0]) / (b[0] - a[0]);
        var eased = local < 0.5 ? 2 * local * local : 1 - Math.pow(-2 * local + 2, 2) / 2;
        set(a[1] + (b[1] - a[1]) * eased);
        if (k < 1) requestAnimationFrame(frame);
      }
      setTimeout(function () { requestAnimationFrame(frame); }, 250);
    }, { threshold: 0.6 });
    io.observe(fig);
  }

  // Finish lineup: spotlight the hovered or focused holder.
  function initLineup(fig) {
    fig.querySelectorAll('[data-lineup-spot]').forEach(function (spot) {
      function on() {
        fig.style.setProperty('--spot-x', spot.style.getPropertyValue('--x'));
        fig.classList.add('is-spotlit');
      }
      function off() { fig.classList.remove('is-spotlit'); }
      spot.addEventListener('pointerenter', on);
      spot.addEventListener('focus', on);
      spot.addEventListener('pointerleave', off);
      spot.addEventListener('blur', off);
    });
  }

  // Full-screen product photos: swipe, arrow keys or buttons.
  function initLightbox(root) {
    var dialog = root.querySelector('[data-lightbox]');
    var openBtn = root.querySelector('[data-lightbox-open]');
    if (!dialog || !openBtn || typeof dialog.showModal !== 'function') {
      if (openBtn) openBtn.hidden = true;
      return;
    }
    var track = dialog.querySelector('[data-lightbox-track]');
    var slides = track.querySelectorAll('.lightbox__slide');
    var count = dialog.querySelector('[data-lightbox-count]');
    var mainImg = root.querySelector('.gallery__main img');
    function index() { return Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)); }
    function label() {
      var tpl = (window.theme && theme.strings.photoCount) || '__I__ / __N__';
      count.textContent = tpl.replace('__I__', index() + 1).replace('__N__', slides.length);
    }
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }
    function open() {
      var current = root.querySelector('[data-gallery-thumb][aria-current="true"]');
      var id = current ? current.getAttribute('data-media-id') : null;
      var start = 0;
      slides.forEach(function (s, i) { if (s.getAttribute('data-media-id') === id) start = i; });
      dialog.showModal();
      document.documentElement.classList.add('is-locked');
      track.scrollLeft = start * track.clientWidth;
      label();
      track.focus({ preventScroll: true });
    }
    openBtn.addEventListener('click', open);
    // On desktop the thumbnails form a large photo grid; clicking one opens it full screen.
    var desktop = window.matchMedia('(min-width: 990px)');
    root.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      t.addEventListener('click', function () { if (desktop.matches) open(); });
    });
    if (mainImg) { mainImg.style.cursor = 'zoom-in'; mainImg.addEventListener('click', open); }
    dialog.querySelector('[data-lightbox-close]').addEventListener('click', function () { dialog.close(); });
    dialog.querySelector('[data-lightbox-prev]').addEventListener('click', function () { go(index() - 1); });
    dialog.querySelector('[data-lightbox-next]').addEventListener('click', function () { go(index() + 1); });
    dialog.addEventListener('close', function () { document.documentElement.classList.remove('is-locked'); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog || e.target.classList.contains('lightbox__slide')) dialog.close(); });
    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(index() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(index() - 1); }
    });
    var t;
    track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(label, 60); }, { passive: true });
  }


  /* ---------- Homepage quick buy (spotlight) ---------- */
  function initSpotlight(form) {
    if (form.dataset.ready) return;
    form.dataset.ready = '1';
    var dataEl = form.querySelector('[data-spot-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = form.querySelector('[data-spot-id]');
    var addBtn = form.querySelector('[data-spot-add]');
    var errorEl = form.querySelector('[data-spot-error]');
    var fieldsets = form.querySelectorAll('[data-spot-option]');
    var section = form.closest('.spotlight');
    var mediaImg = section && section.querySelector('.spotlight__media img');
    var money = function (cents) {
      var d = cents / 100;
      return '$' + (d % 1 ? d.toFixed(2) : d.toFixed(0));
    };

    function update() {
      var chosen = variants[0].options.slice();
      fieldsets.forEach(function (fs) {
        var i = parseInt(fs.getAttribute('data-spot-option'), 10);
        var checked = fs.querySelector('input:checked');
        if (checked && !isNaN(i)) chosen[i] = checked.value;
        var label = fs.querySelector('[data-spot-selected]');
        if (label && checked) label.textContent = checked.value;
      });
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === chosen[i]; }); });
      if (!v) { addBtn.disabled = true; addBtn.textContent = window.theme.strings.unavailable || 'Unavailable'; return; }
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available
        ? window.theme.strings.addToCartPrice.replace('__PRICE__', money(v.price))
        : window.theme.strings.soldOut;
      if (mediaImg && v.featured_image && v.featured_image.src) {
        var src = v.featured_image.src.split('?')[0];
        mediaImg.removeAttribute('srcset');
        mediaImg.src = src + '?width=1100';
      }
    }
    form.addEventListener('change', update);

    form.addEventListener('submit', function (e) {
      if (!drawer) return; // without the drawer, post the form to /cart/add as usual
      e.preventDefault();
      var label = addBtn.textContent;
      addBtn.disabled = true;
      addBtn.textContent = window.theme.strings.adding;
      cartRequest(window.theme.routes.cart_add_url, { items: [{ id: parseInt(idInput.value, 10), quantity: 1 }] })
        .then(function (res) { renderSections(res.sections); if (errorEl) errorEl.textContent = ''; openDrawer(); })
        .catch(function (err) { if (errorEl) errorEl.textContent = err.message; })
        .finally(function () { addBtn.disabled = false; addBtn.textContent = label; });
    });
  }

  function init() {
    document.querySelectorAll('[data-announcement]').forEach(initAnnouncement);
    initMenu();
    document.querySelectorAll('[data-ritual]').forEach(initRitual);
    document.querySelectorAll('[data-buy-bar]').forEach(initBuyBar);
    initCart();
    document.querySelectorAll('[data-product]').forEach(initProduct);
    document.querySelectorAll('[data-spotlight-form]').forEach(initSpotlight);
    document.querySelectorAll('[data-product]').forEach(initLightbox);
    document.querySelectorAll('[data-compare]').forEach(initCompare);
    document.querySelectorAll('[data-lineup]').forEach(initLineup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Re-initialise sections when edited in the theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target;
    t.querySelectorAll('[data-announcement]').forEach(initAnnouncement);
    t.querySelectorAll('[data-ritual]').forEach(initRitual);
    t.querySelectorAll('[data-buy-bar]').forEach(initBuyBar);
    t.querySelectorAll('[data-product]').forEach(initProduct);
    t.querySelectorAll('[data-spotlight-form]').forEach(initSpotlight);
    t.querySelectorAll('[data-product]').forEach(initLightbox);
    t.querySelectorAll('[data-compare]').forEach(initCompare);
    t.querySelectorAll('[data-lineup]').forEach(initLineup);
    if (t.querySelector('[data-cart-drawer]')) drawer = t.querySelector('[data-cart-drawer]');
    if (t.querySelector('[data-menu-toggle]')) initMenu();
  });
})();
